export class EventModel {
    public id: number;
    public name: string;
    public description: string;
    public date: Date;
    public datef: Date;
    public status: number;
    public created: Date;
    public common: number;
    
    constructor() {
        this.id = 0;
    }
}